import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapCollection } from '../ruutsApi/normalize'

export const uploadFarmSubdivisionTemplate = async ({ file, farmId }) => {
  const formData = new FormData()
  formData.append('file', file, file.name)
  formData.append('farmId', farmId)

  const response = await apiClient.post(endpoints.farmSubdivisionsTemplate, formData)
  return unwrapCollection(response)
}
